export default "__VITE_ASSET__D13etL$B__"